import {
  GET_CLOSING_GIFT_PRICE_RANGE,
  GET_CLOSING_GIFT_PRICE_RANGE_SUCCESS,
  GET_CLOSING_GIFT_PRICE_RANGE_FAIL,
  CLOSINGGIFTDETAILS_LOAD,
  CLOSINGGIFTDETAILS_LOAD_SUCCESS,
  CLOSINGGIFTDETAILS_LOAD_FAIL,
} from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  closingGiftPriceRangeInfo: null,
  extraData: {},
  closingGiftDetails: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CLOSING_GIFT_PRICE_RANGE:
      return {
        ...state,
        loading: true,
      };
    case GET_CLOSING_GIFT_PRICE_RANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        closingGiftPriceRangeInfo: action.result.status.status === 'success' ? action.result.closingGiftPriceRangeInfo : null,
        // closingGiftPriceRangeInfo: { currentGiftAmountTotal: 59224.11, requiredGiftAmountTotal: 5000 },
        error: action.result.status.status === 'Failure' ? action.result.status : null,
        extraData: 'This is extra info..........',
      };
    case GET_CLOSING_GIFT_PRICE_RANGE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case CLOSINGGIFTDETAILS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case CLOSINGGIFTDETAILS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        closingGiftDetails: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case CLOSINGGIFTDETAILS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        closingGiftDetails: null,
        error: action.error,
      };
    default:
      return state;
  }
}
